import { defineMessages } from 'react-intl';

export default defineMessages({
  importContent: 'Import content',

  structure: 'Structure',
  block: 'Block',
  pageBreak: 'Page break',
  text: 'Text',
  intro: 'Invitation',

  questionTypes: 'Question types',
  radio: 'Single choice',
  checkbox: 'Multiple choice',
  field: 'Text answer',
  zip: 'Zip code',
  country: 'Country',
  sentiment: 'Sentiment',
  thumbs: 'Thumbs',
  contact: 'Contact Me',
  nps: 'NPS',
  grade: 'Rating',
});
